import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: "/cashier",
  routes: [
    {
      path: "/linkfailure.html",
      name: "linkfailure",
      meta: {
        title: '中宏保险'
      },      
      component: () => import("../components/link-failure.vue")
    },
    {
      path: "/ordersuccess.html",
      name: "ordersuccess",
      meta: {
        title: '中宏保险'
      },
      component: () => import("../components/order-success.vue")
    },
    {
      path: "/paysuccess.html",
      name: "paysuccess",
      meta: {
        title: '中宏保险'
      },      
      component: () => import("../components/pay-success.vue")
    },
    {
      path: "/payfailed.html",
      name: "payfailed",
      meta: {
        title: '中宏保险'
      },      
      component: () => import("../components/pay-failed.vue")
    },
    {
      path: "/payprocess.html",
      name: "payprocess",
      meta: {
        title: '中宏保险'
      },      
      component: () => import("../components/pay-process.vue")
    },
    {
       path: "/aipgpay.html", 
       name: "aipgpay",
       meta: {
        title: '中宏保险'
       },       
       component: () => import("../components/aipg-pay.vue")
    },
    {
      path: "/bocompay.html",
      name: "bocompay",
      meta: {
        title: '中宏保险'
      },
      component: () => import("../components/bocom-pay.vue")
    },
    ,
    {
      path: "/bankcard.html",
      name: "bankcard",
      meta: {
        title: '中宏保险'
      },
      component: () => import("../components/bank-card-add.vue")
    },

    {
      path: "/weixinprocess.html",
      name: "weixinprocess",
      meta: {
        title: '中宏保险'
      },
      component: () => import("../components/weixin-process.vue")
    },
    {
      path: "/weixinsuccess.html",
      name: "weixinsuccess",
      meta: {
        title: '中宏保险'
       },         
      component: () => import("../components/weixin-success.vue")
    },
    {
      path: "/auth.html",
      name: "auth",
      meta: {
        title: '中宏保险'
       },         
      component: () => import("../components/sign-verify.vue")
    },
    {
      path: "/sign.html",
      name: "sign",
      meta: {
        title: '中宏保险'
       },         
      component: () => import("../components/pay-sign.vue")
    },
    {
      path: "/authverify.html",
      name: "authcerify",
      meta: {
        title: '中宏保险'
      },
      component: () => import("../components/auth-verify.vue") 
    },

    {
      path: "/authorder.html",
      name: "authorder",
      meta: {
        title: '中宏保险'
       },         
      component: () => import("../components/auth-order.vue")
    },
    {
      path: "/ccbAuthorder.html",
      name: "ccbauthorder",
      meta: {
        title: '中宏保险'
       },         
      component: () => import("../components/ccb-auth-order.vue")
    },
    {
      path: "/cmb.html",
      name: "cmb-rediractUrl",
      meta: {
        title: '中宏保险'
       },         
      component: () => import("../components/cmb-auth-redirect.vue")
    },
    {
      path: "/signsuccess.html",
      name: "signsuccess",
      meta: {
        title: '中宏保险'
       },         
      component: () => import("../components/sign-success.vue")
    },
    {
      path: "/signfailed.html",
      name: "signfailed",
      meta: {
        title: '中宏保险'
       },         
      component: () => import("../components/sign-failed.vue")
    },
    {
      path: "/weixinredirect.html",
      name: "weixinredirect",
      meta: {
        title: '中宏保险'
       },         
      component: () => import("../components/weixin-jsapipay.vue")
    },  
    {
      path: "/weixincode.html",
      name: "weixincode",
      meta: {
        title: '中宏保险'
       },         
      component: () => import("../components/weixin-code.vue")
    },  
    {
      path: "/weixinorder.html",
      name: "weixinorder",
      meta: {
        title: '中宏保险'
       },         
      component: () => import("../components/weixin-order.vue")
    },
    {
      path: "/renewalcardadd.html",
      name: "renewal-card-add",
      meta: {
        title: '中宏保险'
      },
      component: () => import("../components/renewal-card-add.vue")
    },
    ,
    {
      path: "/renewalsign.html",
      name: "renewal-sign",
      meta: {
        title: '中宏保险'
      },
      component: () => import("../components/renewal-sign.vue")
    },
    {
      path: "/renewalsmsreply.html",
      name: "renewal-sms-reply",
      meta: {
        title: '中宏保险'
      },
      component: () => import("../components/renewal-sms-reply.vue")
    },

    {
       path: "/commonsuccess.html",
       name: "commonsuccess",
       meta: {
        title: '中宏保险'
       },       
       component: ()=> import("../components/common-success.vue")
    },
    {
      path: "/505",
      meta: {
        title: '中宏保险'
      },      
      component: () => import("../components/505.vue")
    },    
    {
      path: "/404",
      meta: {
        title: '中宏保险'
      },      
      component: () => import("../components/not-found.vue")
    },
    {
      path: "*",
      meta: {
        title: '中宏保险'
      },      
      component: () => import("../components/not-found.vue")
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js